/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_No_Match_TitleInputs */

const id_tld_pricing_no_match_title = /** @type {(inputs: Tld_Pricing_No_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada TLD yang cocok`)
};

const en_tld_pricing_no_match_title = /** @type {(inputs: Tld_Pricing_No_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No TLD matches`)
};

/**
* | output |
* | --- |
* | "No TLD matches" |
*
* @param {Tld_Pricing_No_Match_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_no_match_title = /** @type {((inputs?: Tld_Pricing_No_Match_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_No_Match_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_no_match_title(inputs)
	return id_tld_pricing_no_match_title(inputs)
});